var config = require("../config.js");
module.exports = [{
  id: 0,
  name: "Reflex Sight",
  src: "attach_0",
  dotSrc: "dot_0",
  aimOffY: 0.16,
  scale: 1.2,
  expScale: 12
}, {
  id: 1,
  name: "Acog Scope",
  src: "attach_1",
  dotSrc: "dot_0",
  minRec: 20,
  req: function (p12414, p12415) {
    var v9873 = p12414 && p12414.stats && p12414.stats["c" + p12415] ? p12414.stats["c" + p12415] : 0;
    var v9874 = Math.max(1, Math.floor(config.rankVar * Math.sqrt(v9873)) + 1);
    return !!p12414 && !!p12414.isDev || v9874 >= this.minRec;
  },
  zRec: 0.9,
  aimOffY: 0.22,
  zoomMlt: 1.35,
  zOff: 0.35,
  yOff: {
    1: 0.01,
    14: -0.01
  },
  scale: 1.1,
  expScale: 8,
  noVertM: true
}];